import { render, staticRenderFns } from "./TeachRoomExt2.vue?vue&type=template&id=739713e2&scoped=true&"
import script from "./TeachRoomExt2.vue?vue&type=script&lang=js&"
export * from "./TeachRoomExt2.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomExt2.vue?vue&type=style&index=0&id=739713e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739713e2",
  null
  
)

export default component.exports